/**
 * Shared constants and re-exports for type validators.
 * All validators use the same stage number and issue helpers.
 *
 * AUDIT v1.4 / Sprint 4 (C21, V1b): stage number is sourced from the central
 * stage-definitions file. TYPE shares stage 1 with SCHEMA by design — see
 * PEDAGOGICAL_CONTRACT_SPEC §8b.6.
 */

import type { ValidationIssue, PipelineStage } from '../../issueContract'
import { blocker, coach, info } from '../../issueContract'
import { STAGES } from '../../stageDefinitions'

export const STAGE: PipelineStage = STAGES.TYPE // Stage 1b shares stage number with schema

export { blocker, coach, info }
export type { ValidationIssue }
